import React from "react";
import { Box, Paper, Grid, Typography } from "@material-ui/core";
import { CardItem } from "./CardItem";

interface Props {
  ivrRowData: any;
  index: any;
}

export const Card = ({ ivrRowData, index }: Props) => {
  const {
    vendor,
    startDateTime,
    endDateTime,
    hours,
    tech,
    inputBy,
    inputDate,
    vendorNumber,
    callerId,
  } = ivrRowData;
  return (
    <>
      <Paper elevation={1} square>
        <Box p={2} mb={3}>
          <Grid container direction="row" key={index} xs={10} md={12}>
            <CardItem field="Vendor Name" value={vendor} />
            <CardItem field="Vendor Number" value={vendorNumber} />
            <CardItem field="Start" value={startDateTime} isDateField />
            <CardItem field="End" value={endDateTime} isDateField />
            <CardItem field="Hours" value={hours} />
            <CardItem field="Techs" value={tech} />
            <CardItem field="Input By" value={inputBy} />
            <CardItem field="Input Date" value={inputDate} isDateField />
            <CardItem field="Caller ID" value={callerId} />
          </Grid>
        </Box>
      </Paper>
    </>
  );
};
